export default "__VITE_ASSET__CqmtVFib__"